import styled from 'styled-components';
import { breakpoints, colorCSS } from '../../styles';
export const Frame = styled.div `
  display: flex;
  flex-direction: column;
  //gap not supported in safari when flex-direction: column-reverse
  > div:first-child {
    margin-bottom: 1.5rem;
  }
  @media (min-width: ${breakpoints.lg}px) {
    flex-direction: column-reverse;
    > div:first-child {
      margin-bottom: 0;
    }
    > div:last-child {
      margin-bottom: 1.5rem !important;
    }
  }
`;
export const Mask = styled.div `
  overflow: hidden;
`;
export const Track = styled.div `
  align-items: stretch;
  display: flex;
`;
export const Slide = styled.div `
  box-sizing: content-box;
  pointer-events: none;
  user-select: none;
  width: 100%;
  a {
    pointer-events: auto;
  }
`;
export const Controls = styled.div `
  align-items: center;
  justify-content: space-around;
  display: flex;
  gap: 1.5rem;
  @media (min-width: ${breakpoints.lg}px) {
    justify-content: flex-end;
  }
`;
export const Arrow = styled.button `
  align-items: center;
  background-color: ${colorCSS('N0')};
  border: 1px solid ${colorCSS('N20')};
  cursor: pointer;
  display: none;
  height: 2.5rem;
  justify-content: center;
  outline: none !important;
  width: 2.5rem;
  svg {
    max-height: 1rem;
    max-width: 1rem;
    path {
      fill: ${colorCSS('N800')};
    }
  }
  &:hover {
    border-color: ${colorCSS('N40')};
    svg path {
      fill: ${colorCSS('T300')} !important;
    }
  }
  &:focus svg path {
    fill: ${colorCSS('N100')};
  }
  @media (min-width: ${breakpoints.lg}px) {
    display: flex;
  }
`;
export const ArrowPrev = styled(Arrow) `
  svg {
    margin-left: -0.25rem;
  }
`;
export const ArrowNext = styled(Arrow) `
  svg {
    margin-right: -0.25rem;
  }
`;
export const Dots = styled.div `
  align-items: center;
  display: ${({ mobile }) => (mobile ? 'flex' : 'none')};
  gap: 0.5rem;
  @media (min-width: ${breakpoints.lg}px) {
    display: ${({ desktop }) => (desktop ? 'flex' : 'none')};
  }
`;
export const Dot = styled.button `
  background-color: ${colorCSS('N800')};
  border: 0;
  border-radius: 0.25rem;
  cursor: pointer;
  display: block;
  height: 0.5rem;
  padding: 0;
  transition: all 0.25s ease;
  width: 0.5rem;
  &:hover,
  &:focus {
    background-color: ${colorCSS('T300')};
    outline: none;
  }
  &[data-selected='true'] {
    background-color: ${colorCSS('T300')};
    width: 3.75rem;
  }
`;
//# sourceMappingURL=Carousel.styles.js.map